var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error" }, [
    _c("div", { staticClass: "error-img" }, [
      _c("img", { attrs: { src: _vm.getImgUrl(), alt: "" } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "error-message", attrs: { role: "alert" } },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f41e26b", { render: render, staticRenderFns: staticRenderFns })
  }
}